module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('bottom-toolbar'), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "subNavTitle": "New Group",
      "returnPreviousPage": true,
      "menuAccess": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "layoutTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 offset-md-1"
  }, [_c('div', {
    staticClass: "panel21 panel-default"
  }, [_vm._m(0), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-7 col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.label),
      expression: "label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Group name"
    },
    domProps: {
      "value": (_vm.label)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.label = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-5 col-sm-2 col-form-label test-title subtitleDebtorList"
  }, [_vm._v("My contacts")]), _vm._v(" "), _c('div', {
    staticClass: "col-7 offset-sm-7 col-sm-3"
  }, [_c('a', {
    attrs: {
      "href": "/account/addContactGroupContactList/"
    }
  }, [_c('span', {
    staticClass: "button button-round button-inner-color",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(this.selected.length) + " selected")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(Object.keys(this.selectedDebtors).length > 0) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_vm._v("Contacts in this group")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(Object.keys(this.selectedDebtors).length !== 0) ? _c('ul', {
    staticClass: " offset-sm-1 col-sm-10 list-group"
  }, _vm._l((this.selectedDebtors), function(value) {
    return _c('li', {
      key: value.id,
      staticClass: "list-group-item"
    }, [_vm._v(_vm._s(value.label))])
  }), 0) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 offset-md-9"
  }, [_c('button', {
    staticClass: "button-action firstButtonMarginTop",
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.addContactGroup
    }
  }, [_c('i', {
    staticClass: "icon fa fa-save"
  }), _vm._v(" "), _c('span', [_vm._v("Save")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "content-block labelAccordionForm"
  }, [_c('i', {
    staticClass: "fa fa-address-book formIcon"
  }), _vm._v("\n                      Add Group\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-5 col-sm-2 col-form-label"
  }, [_c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")]), _vm._v("Group name")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-36c0034d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36c0034d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contacts/CMAddContactGroup.vue
// module id = 1652
// module chunks = 2